import React from 'react';
import Nav from "./components/nav/nav";

import './App.css';

function App() {
  return (
      <Nav />
  );
}

export default App;
